import ProductService from '../services/product.service';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { PRODUCTS_LIST_KEY } from 'modules/inventory/product/constants';

const useUpdateProductTop = (productId: string) => {
  const { t } = useTranslation(['product', 'errors']);
  const queryClient = useQueryClient();

  const { mutateAsync, isPending: isLoading, data } = useMutation(
    (top: boolean) => ProductService.updateTop(productId, top),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [PRODUCTS_LIST_KEY] });
        toast.success(t('successInternalSeoUpdate'));
      },
      onError: () => {
        toast.error(t('generalErrorMessage', { ns: 'errors' }));
      },
    },
  );

  return {
    updateTop: mutateAsync,
    isLoading,
    value: (data as any)?.data?.internalSeo?.top,
  };
};

export default useUpdateProductTop;
